import React from 'react';

import { Box } from '@chakra-ui/react';
import { Add } from '@mesh.ai/rabbit';
import { BulkActionsSplitButton } from 'screens/performanceReview/manageAndInsights/ReviewManage/components/ReviewManageTable/components/BulkActions/BulkActionsSplitButton';

import { DISCIPLINARY_ACTIONS_INTENT_ID_MAP } from 'constants/moduleIntentTypes';

import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { useBulkActionContext } from './BulkActionContext';

export interface BulkActionHeaderProps {
  clearSelection: () => void;
  selectAll: () => void;
  handleApproveAll: () => void;
  handleDenyAll: () => void;
  handleNotifyAll: () => void;
  onAddViolation: () => void;
  intentId: string;
}

export type BulkActionOptionsType = {
  value: string;
  label: string;
  onClick?: () => void;
  icon?: React.FC<unknown>;
  isDisabled?: boolean;
  isSubMenu?: boolean;
  subActions?: BulkActionOptionsType[];
};

export const BulkActionHeader: React.FC<BulkActionHeaderProps> = ({
  clearSelection,
  selectAll,
  handleApproveAll = () => {},
  handleDenyAll = () => {},
  handleNotifyAll = () => {},
  onAddViolation = () => {},
  intentId,
}) => {
  const { selectedDisciplinaryActionIds, totalDisciplinaryActions } = useBulkActionContext();

  const totalRows = totalDisciplinaryActions;
  const totalRowsSelected = selectedDisciplinaryActionIds.length;

  const actions: BulkActionOptionsType[] = [
    {
      value: 'Approve all',
      label: 'Approve all',
      onClick: () => handleApproveAll(),
      isDisabled: selectedDisciplinaryActionIds.length === 0,
    },
    {
      value: 'Deny all',
      label: 'Deny all',
      onClick: () => handleDenyAll(),
      isDisabled: selectedDisciplinaryActionIds.length === 0,
    },
  ];

  if (intentId === DISCIPLINARY_ACTIONS_INTENT_ID_MAP.ALL) {
    actions.push({
      value: 'Notify all',
      label: 'Notify all',
      onClick: () => handleNotifyAll(),
      isDisabled: selectedDisciplinaryActionIds.length === 0,
    });
  }

  return totalRows > 0 ? (
    <Box display="flex" alignItems="center" mb={3}>
      <Box
        display="flex"
        px="12px"
        py={1}
        alignItems="center"
        bgColor="neutral.F5F7F9"
        borderWidth="1px"
        borderColor="neutral.EBEFF3"
        borderRadius="4px"
        flex={1}
      >
        {totalRows === totalRowsSelected ? (
          <TextBodyMedium bold>
            All {totalRowsSelected > 1 ? `${totalRowsSelected} ` : ''} disciplinary actions are selected
          </TextBodyMedium>
        ) : (
          totalRowsSelected > 0 && (
            <TextBodyMedium bold>
              Total {totalRowsSelected} {totalRowsSelected > 1 ? 'disciplinary actions are' : 'disciplinary action is'}{' '}
              selected
            </TextBodyMedium>
          )
        )}
        {totalRows !== totalRowsSelected && (
          <Button variant="tertiary" onClick={selectAll}>
            Select all {totalRows} disciplinary actions
          </Button>
        )}
        {totalRowsSelected > 0 && (
          <Button variant="tertiary" onClick={clearSelection}>
            Clear Selection
          </Button>
        )}
        <Box ml="auto">
          <BulkActionsSplitButton options={actions} isDisabled={selectedDisciplinaryActionIds.length === 0} />
        </Box>
      </Box>
      <Box ml="12px">
        <Button StartIcon={Add} onClick={onAddViolation}>
          Add new note
        </Button>
      </Box>
    </Box>
  ) : (
    <Box display="flex" justifyContent="flex-end">
      <Button StartIcon={Add} onClick={onAddViolation}>
        Add new note
      </Button>
    </Box>
  );
};
